var jsPDF = require("jspdf");
jsPDF = jsPDF.API ? jsPDF : jsPDF.default;
var util = require("./util");
var PDFBlock = require("./block");
var pageFormats = require("./pageSizes");
function PDFSectionContent(options) {
    options = options || {};
    this.verticalAlign = util.getOption(options, "verticalAlign", "top");
    this.verticalAlignFirst = util.getOption(options, "verticalAlignFirst", this.verticalAlign);
}
PDFSectionContent._listeners = [];
PDFSectionContent.addListener = function (cb) {
    PDFSectionContent._listeners.push(cb);
};
PDFSectionContent.removeListener = function (cb) {
    PDFSectionContent._listeners = PDFSectionContent._listeners.filter(function (listener) {
        return listener !== cb;
    });
};
PDFSectionContent.triggerListeners = function () {
    var args = Array.prototype.slice.call(arguments, 0);
    var ret, listener;
    for (var i = 0; i < PDFSectionContent._listeners.length; i++) {
        listener = PDFSectionContent._listeners[i];
        if (typeof listener === "function")
            ret = listener.apply(null, args);
        if (typeof ret !== "undefined")
            return ret;
    }
};
PDFSectionContent.prototype.calc = function (cursor) {
    return PDFSectionContent.triggerListeners(cursor, false);
};
PDFSectionContent.prototype.draw = function (cursor) {
    var drawCursor = util.extend({}, cursor, {
        __sectionVerticalAlign: this.verticalAlign,
        __sectionVerticalAlignFirst: this.verticalAlignFirst,
    });
    return PDFSectionContent.triggerListeners(drawCursor, true);
};
function PDFSection(options, template, content) {
    options = options || {};
    this.format = util.getOption(options, "format", "letter");
    this.compress = util.getOption(options, "compress", false);
    this.orientation = util.getOption(options, "orientation", "portrait").toLowerCase();
    if (Array.isArray(this.format)) {
        this.pageWidth = this.format[0];
        this.pageHeight = this.format[1];
    }
    else if (typeof this.format === "string") {
        this.pageWidth = pageFormats[this.format][0];
        this.pageHeight = pageFormats[this.format][1];
    }
    if (isNaN(this.pageWidth) || isNaN(this.pageHeight))
        throw new Error('PDFSection: "' + this.format + '" is an invalid format.');
    if (this.orientation === "landscape" && this.pageWidth < this.pageHeight) {
        var tmpWidth = this.pageWidth;
        this.pageWidth = this.pageHeight;
        this.pageHeight = tmpWidth;
    }
    if (!(template instanceof PDFBlock))
        throw new TypeError("PDFSection: the template must be a block.");
    if (!(content instanceof PDFBlock))
        throw new TypeError("PDFSection: the content must be a block.");
    this.template = template;
    this.content = content;
}
PDFSection.SectionContent = PDFSectionContent;
PDFSection.prototype.getContentCursor = function (cursor) {
    var ret;
    function cb(cursor) {
        ret = cursor;
        return { width: 0, height: 0 };
    }
    PDFSectionContent.addListener(cb);
    try {
        this.template.invalidate();
        this.template.calc(cursor);
    }
    catch (e) {
        PDFSectionContent.removeListener(cb);
        throw e;
    }
    PDFSectionContent.removeListener(cb);
    return util.extend({}, ret, { _firstOfPage: true, _lastOfPage: true });
};
PDFSection.prototype.getTemplateCursor = function (doc) {
    return {
        x: 0,
        y: 0,
        width: this.pageWidth,
        height: this.pageHeight,
        doc: doc,
    };
};
PDFSection.prototype.getPages = function (doc) {
    var cursor = this.getTemplateCursor(doc);
    var contentCursor = this.getContentCursor(cursor);
    return this.content.splitToHeight(contentCursor);
};
PDFSection.prototype.getNumberOfPages = function (doc) {
    this._splitContents = this.getPages(doc);
    return this._splitContents.length;
};
PDFSection.prototype.draw = function (doc, skipPage) {
    if (!doc) {
        skipPage = true;
        doc = new jsPDF({
            orientation: this.orientation,
            unit: "pt",
            format: [this.pageWidth, this.pageHeight],
            compress: this.compress,
        });
    }
    var splitContents = this._splitContents || this.getPages(doc);
    splitContents.forEach(function (content, i) {
        function cb(cursor, isDraw) {
            if (!isDraw)
                return { width: 0, height: 0 };
            var contentCursor = util.extend({}, cursor, { _firstOfPage: true, _lastOfPage: true });
            var contentCalc;
            var vAlign = i === 0 ? contentCursor.__sectionVerticalAlignFirst : contentCursor.__sectionVerticalAlign;
            if (vAlign === "bottom") {
                contentCalc = content.calc(contentCursor);
                contentCursor.y = contentCursor.y + contentCursor.height - contentCalc.height;
            }
            if (vAlign === "middle") {
                contentCalc = content.calc(contentCursor);
                contentCursor.y = contentCursor.y + contentCursor.height / 2 - contentCalc.height / 2;
            }
            return content.draw(contentCursor);
        }
        PDFSectionContent.addListener(cb);
        try {
            if (!skipPage)
                doc.addPage([this.pageWidth, this.pageHeight], this.orientation);
            skipPage = false;
            var cursor = this.getTemplateCursor(doc);
            this.template.draw(cursor);
        }
        catch (e) {
            PDFSectionContent.removeListener(cb);
            throw e;
        }
        PDFSectionContent.removeListener(cb);
    }, this);
    return doc;
};
module.exports = PDFSection;
//# sourceMappingURL=module.js.map